import React, { Component } from 'react';
import ErrorPage from './ErrorPage';
import Layout from '../layout/Layout';
import {
    Dashboard, ChangeLog, Inquiry, ViewPastSubmission, ClientAlert, AckReport, ActuaryReport
    , CancellationReport, CashflowReport, TrustReport, Hold, RequestedHold, PaymentAdjustment
    , PaymentReport, PaymentAdjustmentSubmission, Cancellation, CancellationPending, InventoryReport
    , UpdateProfile, ChangePassword, UserGuide, Keyword, GlobalGuide, User, AddUser, UserGroup, NewAccount
    , Mails, ViewAccount, SavedSearch, EDIUpload
} from './';
import { Route } from 'react-router-dom';
import IdentityManager from './administrations/IdentityManager';
import AddIdentityManager from './administrations/AddIdentityManager';
import IdentityMapping from './administrations/IdentityMapping';
import AddIdentityGroup from './administrations/AddIdentityGroup';

import SearchClient from './client/SearchClient';
import ClientAction from './client/ClientAction';

class Protected extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clients: []
        }
    }

    render() {
        return (
            <Layout {...this.props} >
                <Route path={"/404"} exact render={() => <ErrorPage />} />
                <Route path={"/CHANGELOG"} exact render={() => <ChangeLog />} />
                <Route path={"/home"} exact render={() => <Dashboard {...this.props} />} />
                <Route path={"/home/:token"} exact render={(match) => <Dashboard params={match.match.params} {...this.props} />} />
                {/* Account Management */}
                {
                    // eslint-disable-next-line
                    this.props.items.menuItems.map((menu, index) => {
                        if (menu.id === 1) {
                            return (
                                <div key={index}>
                                    <Route path={"/inquiry"} exact render={() => <Inquiry {...this.props} />} />
                                    <Route path={"/alert"} exact render={() => <ClientAlert {...this.props} />} />
                                    <Route path={"/account"} exact render={() => <NewAccount {...this.props} />} />
                                    <Route path={"/ediupload"} exact render={() => <EDIUpload {...this.props} />} />
                                    <Route path={"/view/account/:id"} exact render={(match) => <NewAccount params={match.match.params} {...this.props} />} />
                                    <Route path={"/view/consumer/:id"} exact render={(match) => <ViewAccount params={match.match.params} {...this.props} />} />
                                    <Route path={"/view/submission"} exact render={() => <ViewPastSubmission  {...this.props} />} />
                                    <Route path={"/hold"} exact render={() => <Hold {...this.props} />} />
                                    <Route path={"/hold/:id"} exact render={(match) => <Hold params={match.match.params} {...this.props} />} />
                                    <Route path={"/view/hold"} exact render={() => <RequestedHold {...this.props} />} />
                                </div>
                            )
                        }
                    })
                }
                {/* Payments */}
                {
                    // eslint-disable-next-line
                    this.props.items.menuItems.map((menu, index) => {
                        if (menu.id === 2) {
                            return (
                                <div key={index}>
                                    <Route path={"/payment"} exact render={() => <PaymentAdjustment  {...this.props} />} />
                                    <Route path={"/payment/:id"} exact render={(match) => <PaymentAdjustment params={match.match.params} {...this.props} />} />
                                    <Route path={"/view/payment"} exact render={() => <PaymentAdjustmentSubmission  {...this.props} />} />
                                </div>
                            )
                        }
                    })
                }

                {/* Cancellation */}
                {
                    // eslint-disable-next-line
                    this.props.items.menuItems.map((menu, index) => {
                        if (menu.id === 3) {
                            return (
                                <div key={index}>
                                    <Route path={"/cancellation"} exact render={() => <Cancellation {...this.props} />} />
                                    <Route path={"/cancellation/:id"} exact render={(match) => <Cancellation params={match.match.params} {...this.props} />} />
                                    <Route path={"/view/cancellation"} exact render={() => <CancellationPending  {...this.props} />} />
                                </div>
                            )
                        }
                    })
                }
                {/* Report */}
                {
                    // eslint-disable-next-line
                    this.props.items.menuItems.map((menu, index) => {
                        if (menu.id === 4) {
                            return menu.child.length > 0 && menu.child.map((childItem, cIndex) => {
                                return (
                                    <div key={cIndex}>
                                        {childItem.menu === "Acknowledgement" && <Route path={"/report/ack"} exact render={() => <AckReport {...this.props} />} />}
                                        {childItem.menu === "Actuary" && <Route path={"/report/actuary"} exact render={() => <ActuaryReport {...this.props} />} />}
                                        {childItem.menu === "Cancellation" && <Route path={"/report/cancellation"} exact render={() => <CancellationReport {...this.props} />} />}
                                        {childItem.menu === "Cashflow" && <Route path={"/report/cashflow"} exact render={() => <CashflowReport {...this.props} />} />}
                                        {childItem.menu === "Inventory" && <Route path={"/report/inventory"} exact render={() => <InventoryReport {...this.props} />} />}
                                        {childItem.menu === "Inventory" && <Route path={"/report/inventory/:id"} exact render={(match) => <InventoryReport params={match.match.params} {...this.props} />} />}
                                        {childItem.menu === "Inventory" && <Route path={"/report/savedSearch"} exact render={() => <SavedSearch {...this.props} />} />}
                                        {childItem.menu === "Payment" && <Route path={"/report/payment"} exact render={() => <PaymentReport {...this.props} />} />}
                                        {childItem.menu === "Trust" && <Route path={"/report/trust"} exact render={() => <TrustReport {...this.props} />} />}
                                    </div>
                                )
                            })

                        }
                    })
                }
                {/* Administration */}
                {
                    // eslint-disable-next-line
                    this.props.items.menuItems.map((menu, index) => {
                        if (menu.id === 5) {
                            return (
                                <div key={index}>
                                    <Route path={"/users"} exact render={() => <User  {...this.props} />} />
                                    <Route path={"/user"} exact render={(match) => <AddUser params={match.match.params} {...this.props} />} />
                                    <Route path={"/user/:id"} exact render={(match) => <AddUser params={match.match.params} {...this.props} />} />
                                    <Route path={"/usergroups"} exact render={() => <UserGroup  {...this.props} />} />
                                    <Route path={"/identity"} exact render={() => <IdentityManager  {...this.props} />} />
                                    <Route path={"/identity/:id"} exact render={(match) => <AddIdentityManager params={match.match.params} {...this.props} />} />
                                    <Route path={"/clientmap"} exact render={() => <IdentityMapping  {...this.props} />} />
                                    <Route path={"/clientmap/:id"} exact render={(match) => <AddIdentityGroup params={match.match.params} {...this.props} />} />
                                </div>
                            )
                        }
                    })
                }
                 {/* Client Management */}
                 {
                    // eslint-disable-next-line
                    this.props.items.menuItems.map((menu, index) => {
                        if (menu.id === 38) {
                            return (
                                <div key={index}>
                                    <Route path={"/search"} exact render={() => <SearchClient  {...this.props} />} />
                                    <Route path={"/clientAction"} exact render={() => <ClientAction  {...this.props} />} />
                                    <Route path={"/clientAction/:id"} exact render={(match) => <ClientAction params={match.match.params} {...this.props} />} />
                                </div>
                            )
                        }
                    })
                }
                {/* Others */}
                <Route path={"/profile"} exact render={() => <UpdateProfile  {...this.props} />} />
                <Route path={"/changepassword/:id?"} exact render={(match) => <ChangePassword params={match.match.params} {...this.props} />} />
                <Route path={"/userguide"} exact render={() => <UserGuide {...this.props} />} />
                <Route path={"/keyword"} exact render={() => <Keyword {...this.props} />} />
                <Route path={"/globalguide"} exact render={() => <GlobalGuide {...this.props} />} />
                {/* Notifications */}
                <Route path={"/mails"} exact render={() => <Mails  {...this.props} />} />
            </Layout >
        );
    }
}

export default (Protected);




// WEBPACK FOOTER //
// ./src/app/ui/Protected.js